export default __webpack_public_path__ + "static/media/zayed-project-6.7a62876f.webp";